// Protokoll — lückenlose Liste der Operator-Aktionen (Phase 4).

import { useEffect, useState } from "react";

import { Loader } from "@/components/Loader";

import { getAudit, OperatorApiError, type AuditEntry } from "./api";

const ACTION_LABELS: Record<string, string> = {
  "firm.create": "Kanzlei angelegt",
  "user.create": "Sachbearbeiter angelegt",
  "botkey.create": "Bot-Key erzeugt",
  "workflow.import": "Workflow importiert",
  "workflow.activate": "Workflow freigeschaltet",
  "workflow.deactivate": "Workflow deaktiviert",
};

function fmtTime(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleString("de-AT", { dateStyle: "short", timeStyle: "short" });
}

function fmtDetail(detail: Record<string, unknown>): string {
  return Object.entries(detail)
    .map(([k, v]) => `${k}: ${String(v)}`)
    .join(" · ");
}

export function AuditPage({ onExpired }: { onExpired: () => void }) {
  const [entries, setEntries] = useState<AuditEntry[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getAudit()
      .then(setEntries)
      .catch((e: unknown) => {
        if (e instanceof OperatorApiError && e.status === 401) onExpired();
        else setError(e instanceof Error ? e.message : "Fehler beim Laden");
      });
  }, [onExpired]);

  if (error) return <p className="op-error">{error}</p>;
  if (!entries) return <Loader label="Protokoll wird geladen…" />;

  return (
    <section>
      <h1 className="op-h1">Protokoll</h1>
      {entries.length === 0 ? (
        <p className="op-empty">Noch keine Aktionen protokolliert.</p>
      ) : (
        <table className="op-table">
          <thead>
            <tr>
              <th>Zeit</th>
              <th>Aktion</th>
              <th>Kanzlei</th>
              <th>Detail</th>
              <th>Operator</th>
            </tr>
          </thead>
          <tbody>
            {entries.map((e) => (
              <tr key={e.id}>
                <td className="op-slug">{fmtTime(e.created_at)}</td>
                <td>{ACTION_LABELS[e.action] ?? e.action}</td>
                <td>{e.firm_slug ?? "—"}</td>
                <td className="op-slug">{fmtDetail(e.detail)}</td>
                <td>{e.operator_email}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
